import { createReducer } from '@reduxjs/toolkit';
const initialState = {};
const reducer = createReducer(initialState, (builder) => builder);
export default reducer;
